export default "__VITE_ASSET__bK63jtxV__"